import { InfoOutlined, SvgIconComponent } from '@mui/icons-material';
import React from 'react';
import { Box, styled } from '@mui/material';
import PopoverTooltip from './PopoverTooltip';

interface HoverExplanationTooltipProps {
  popoverId: string;
  children: React.ReactNode;
  Icon?: SvgIconComponent;
}

const StyledBox = styled(Box)({
  marginLeft: 4,
  lineHeight: 1,
  height: 14,
  '& svg': {
    fontSize: 14,
  },
});

export default function HoverExplanationTooltip(props: HoverExplanationTooltipProps) {
  const { children, popoverId, Icon } = props;

  const ActualIcon = Icon ?? InfoOutlined;
  return (
    <StyledBox>
      <PopoverTooltip
        popoverId={popoverId}
        text={<ActualIcon />}
      >
        {children}
      </PopoverTooltip>
    </StyledBox>
  );
}
